import {isGtmEnabled} from '@amblique/king-living/app/utils/gtm-utils';

export const clearEcom = () => {
  if (typeof window === 'undefined' || !Array.isArray(window.dataLayer) || !isGtmEnabled()) {
    return false;
  }

  window.dataLayer.push({ecommerce: null});

  return true;
};

export const pushEvent = (eventName, params = {}) => {
  if (typeof window === 'undefined' || !Array.isArray(window.dataLayer) || !isGtmEnabled()) {
    return false;
  }

  clearEcom();
  window.dataLayer.push({event: eventName, ...params});

  return true;
};
